import styled, { css } from 'styled-components';
import { Box, Button } from '@bechtel/gds';

export const SummaryContainerStyled = styled.div`
  display: grid;
  grid-template-columns: 45% 55%;
  width: 100%;
`;

export const SummaryContentStyled = styled.div`
  display: grid;
  grid-template-columns: 36px auto;
  grid-column: 1;

  ${({ theme }) => css`
    grid-auto-rows: minmax(${theme.spacings[700]}, auto);
    row-gap: ${theme.spacings[600]};
    column-gap: ${theme.spacings[400]};
  `}
`;

export const DocumentPreviewContainerStyled = styled(Box).attrs({
  flexGrow: { sm: 1 },
  p: { sm: '500' },
})`
  grid-column: 2;
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    border-radius: ${theme.radii[300]};
  `}
`;

export const PdfLoadingButtonContainerStyled= styled(Box).attrs({
  justifyContent: { sm: 'center'},
  alignItems: { sm: 'center' },
})`
height: 100%;
`

export const PdfLoadingButtonStyled = styled(Button)`
width: auto;
`
